import { api } from '../config';
import { ApiResponse } from '@/types';
import { EventTypeResponse, EventTypeUpsertData } from '@/types/eventType.types';

type BackendResponse<T> = ApiResponse<T>;

export const eventTypeService = {
  async getAll(active?: boolean): Promise<ApiResponse<EventTypeResponse[]>> {
    const response = await api.get<BackendResponse<EventTypeResponse[]>>('/event-types', {
      params: active === undefined ? {} : { active },
    });
    return response.data;
  },

  async create(payload: EventTypeUpsertData & { code: string }): Promise<ApiResponse<EventTypeResponse>> {
    const response = await api.post<BackendResponse<EventTypeResponse>>('/event-types', payload);
    return response.data;
  },

  async update(id: string, payload: EventTypeUpsertData): Promise<ApiResponse<EventTypeResponse>> {
    const response = await api.patch<BackendResponse<EventTypeResponse>>(`/event-types/${id}`, payload);
    return response.data;
  },

  async setActive(id: string, active: boolean): Promise<ApiResponse<EventTypeResponse>> {
    const response = await api.patch<BackendResponse<EventTypeResponse>>(
      `/event-types/${id}/active`,
      { active }
    );
    return response.data;
  },

  async countAutoCreated(): Promise<ApiResponse<{ count: number }>> {
    const response = await api.get<BackendResponse<{ count: number }>>('/event-types/auto-created/count');
    return response.data;
  },
};
